const sortBeesByDutchName = (beeIds, beesById) => [...beeIds].sort((a, b) => {
  // ignore upper and lowercase
  const nameA = beesById[a].dutchName.toUpperCase();
  const nameB = beesById[b].dutchName.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
});

export default sortBeesByDutchName;
